import Vue from 'vue'
import Vuex from 'vuex'
import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from '../client/layouts/error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_bootstrapvue_bb3d6a0e from 'nuxt_plugin_bootstrapvue_bb3d6a0e' // Source: ./bootstrap-vue.js (mode: 'all')
import nuxt_plugin_hotjar_3d4d28a0 from 'nuxt_plugin_hotjar_3d4d28a0' // Source: ./hotjar.js (mode: 'client')
import nuxt_plugin_linkedin_65bb9290 from 'nuxt_plugin_linkedin_65bb9290' // Source: ./linkedin.js (mode: 'client')
import nuxt_plugin_moment_aef0d7e4 from 'nuxt_plugin_moment_aef0d7e4' // Source: ./moment.js (mode: 'all')
import nuxt_plugin_toast_1ba1b90e from 'nuxt_plugin_toast_1ba1b90e' // Source: ./toast.js (mode: 'client')
import nuxt_plugin_router_4e288e25 from 'nuxt_plugin_router_4e288e25' // Source: ./router.js (mode: 'all')
import nuxt_plugin_global_0a6ae274 from 'nuxt_plugin_global_0a6ae274' // Source: ../client/components/global (mode: 'all')
import nuxt_plugin_vform_f95cee7a from 'nuxt_plugin_vform_f95cee7a' // Source: ../client/plugins/vform (mode: 'all')
import nuxt_plugin_urls_56d0cd3b from 'nuxt_plugin_urls_56d0cd3b' // Source: ../client/plugins/urls (mode: 'all')
import nuxt_plugin_env_6e038494 from 'nuxt_plugin_env_6e038494' // Source: ../client/plugins/env (mode: 'all')
import nuxt_plugin_axios_fb9c9a02 from 'nuxt_plugin_axios_fb9c9a02' // Source: ../client/plugins/axios (mode: 'all')
import nuxt_plugin_nuxtclientinit_37cfbfdf from 'nuxt_plugin_nuxtclientinit_37cfbfdf' // Source: ../client/plugins/nuxt-client-init (mode: 'all')
import nuxt_plugin_bootstrap_0f900877 from 'nuxt_plugin_bootstrap_0f900877' // Source: ../client/plugins/bootstrap (mode: 'client')
import nuxt_plugin_vuelazyload_f1f534be from 'nuxt_plugin_vuelazyload_f1f534be' // Source: ../client/plugins/vue-lazy-load (mode: 'all')
import nuxt_plugin_vuexpersistedstate_1da59343 from 'nuxt_plugin_vuexpersistedstate_1da59343' // Source: ../client/plugins/vuex-persistedstate (mode: 'client')
import nuxt_plugin_vuexsharedmutations_13a55a87 from 'nuxt_plugin_vuexsharedmutations_13a55a87' // Source: ../client/plugins/vuex-shared-mutations (mode: 'client')
import nuxt_plugin_vueinfiniteloading_ba354f40 from 'nuxt_plugin_vueinfiniteloading_ba354f40' // Source: ../client/plugins/vue-infinite-loading (mode: 'client')
import nuxt_plugin_vuemultiselect_57bfe612 from 'nuxt_plugin_vuemultiselect_57bfe612' // Source: ../client/plugins/vue-multiselect (mode: 'all')
import nuxt_plugin_moneyformat_883ef0c6 from 'nuxt_plugin_moneyformat_883ef0c6' // Source: ../client/plugins/money-format.js (mode: 'all')
import nuxt_plugin_stringformat_e39a9d06 from 'nuxt_plugin_stringformat_e39a9d06' // Source: ../client/plugins/string-format (mode: 'all')
import nuxt_plugin_numberonlyinput_45f437e0 from 'nuxt_plugin_numberonlyinput_45f437e0' // Source: ../client/plugins/number-only-input.js (mode: 'all')
import nuxt_plugin_secondstimestamp_428bd625 from 'nuxt_plugin_secondstimestamp_428bd625' // Source: ../client/plugins/seconds-timestamp.js (mode: 'all')
import nuxt_plugin_vuegtag_9c4c62de from 'nuxt_plugin_vuegtag_9c4c62de' // Source: ../client/plugins/vue-gtag (mode: 'client')
import nuxt_plugin_gtm_5e4639ea from 'nuxt_plugin_gtm_5e4639ea' // Source: ../client/plugins/gtm (mode: 'client')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$nuxt', {
  get() {
    const globalNuxt = this.$root ? this.$root.$options.$nuxt : null
    if (process.client && !globalNuxt && typeof window !== 'undefined') {
      return window.$nuxt
    }
    return globalNuxt
  },
  configurable: true
})

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":false,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

const originalRegisterModule = Vuex.Store.prototype.registerModule

function registerModule (path, rawModule, options = {}) {
  const preserveState = process.client && (
    Array.isArray(path)
      ? !!path.reduce((namespacedState, path) => namespacedState && namespacedState[path], this.state)
      : path in this.state
  )
  return originalRegisterModule.call(this, path, rawModule, { preserveState, ...options })
}

async function createApp(ssrContext, config = {}) {
  const store = createStore(ssrContext)
  const router = await createRouter(ssrContext, config, { store })

  // Add this.$router into store actions/mutations
  store.$router = router

  // Fix SSR caveat https://github.com/nuxt/nuxt.js/issues/3757#issuecomment-414689141
  store.registerModule = registerModule

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"title":"Truestock - Curated Australian stock imagery","titleTemplate":"%s","meta":[{"charset":"utf-8"},{"http-equiv":"content-language","content":"en-AU"},{"name":"viewport","content":"width=device-width, initial-scale=1"},{"hid":"description","name":"description","content":"Exclusive, royalty-free local stock images capturing an authentic, diverse and multicultural Australia."},{"name":"geo.region","content":"AU"},{"name":"geo.country","content":"Australia"},{"name":"robots","content":"index, follow, max-image-preview:large"},{"name":"msapplication-TileColor","content":"#131112"},{"name":"theme-color","content":"#131112"},{"hid":"og:type","property":"og:type","content":"website"},{"hid":"og:title","property":"og:title","content":"Truestock - Curated Australian stock imagery"},{"hid":"og:locale","property":"og:locale","content":"en_AU"},{"hid":"twitter:title","name":"twitter:title","content":"Truestock - Curated Australian stock imagery"},{"hid":"og:description","property":"og:description","content":"Exclusive, royalty-free local stock images capturing an authentic, diverse and multicultural Australia."},{"hid":"twitter:description","name":"twitter:description","content":"Exclusive, royalty-free local stock images capturing an authentic, diverse and multicultural Australia."},{"hid":"twitter:card","name":"twitter:card","content":"summary_large_image"},{"hid":"og:image","property":"og:image","content":"https:\u002F\u002Fassets.truestock.com.au\u002Fdefaults\u002Fsocial-cover.jpg"},{"hid":"twitter:image","name":"twitter:image","content":"https:\u002F\u002Fassets.truestock.com.au\u002Fdefaults\u002Fsocial-cover.jpg"}],"link":[{"rel":"canonical","href":"https:\u002F\u002Ftruestock.com.au"},{"rel":"alternate","hreflang":"en-NZ","href":"https:\u002F\u002Ftruestock.co.nz"},{"rel":"alternate","hreflang":"en-AU","href":"https:\u002F\u002Ftruestock.com.au"},{"rel":"alternate","hreflang":"x-default","href":"https:\u002F\u002Ftruestock.com.au"},{"rel":"shortcut icon","type":"image\u002Fx-icon","href":"\u002Ffavicon.ico?v=0.1"},{"rel":"icon","type":"image\u002Fpng","size":"16x16","href":"\u002Ffavicon-16x16.png?v=0.1"},{"rel":"icon","type":"image\u002Fpng","size":"32x32","href":"\u002Ffavicon-32x32.png?v=0.1"},{"rel":"apple-touch-icon","href":"\u002Fapple-touch-icon.png?v=0.1"},{"rel":"apple-touch-icon","size":"57x57","href":"\u002Fapple-touch-icon-57x57.png?v=0.1"},{"rel":"apple-touch-icon","size":"72x72","href":"\u002Fapple-touch-icon-72x72.png?v=0.1"},{"rel":"apple-touch-icon","size":"76x76","href":"\u002Fapple-touch-icon-76x76.png?v=0.1"},{"rel":"apple-touch-icon","size":"114x114","href":"\u002Fapple-touch-icon-114x114.png?v=0.1"},{"rel":"apple-touch-icon","size":"120x120","href":"\u002Fapple-touch-icon-120x120.png?v=0.1"},{"rel":"apple-touch-icon","size":"144x144","href":"\u002Fapple-touch-icon-144x144.png?v=0.1"},{"rel":"apple-touch-icon","size":"152x152","href":"\u002Fapple-touch-icon-152x152.png?v=0.1"},{"rel":"apple-touch-icon","size":"180x180","href":"\u002Fapple-touch-icon-180x180.png?v=0.1"},{"rel":"manifest","href":"\u002Fsite.webmanifest?v=0.1"},{"rel":"mask-icon","href":"\u002Fsafari-pinned-tab.svg?v=0.1","color":"#131112"}],"style":[],"script":[]},

    store,
    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      errPageReady: false,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        nuxt.errPageReady = false
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    store,
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    beforeSerializeFns: ssrContext ? ssrContext.beforeSerializeFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__NUXT__ && window.__NUXT__.state) {
      store.replaceState(window.__NUXT__.state)
    }
  }

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (typeof nuxt_plugin_bootstrapvue_bb3d6a0e === 'function') {
    await nuxt_plugin_bootstrapvue_bb3d6a0e(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_hotjar_3d4d28a0 === 'function') {
    await nuxt_plugin_hotjar_3d4d28a0(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_linkedin_65bb9290 === 'function') {
    await nuxt_plugin_linkedin_65bb9290(app.context, inject)
  }

  if (typeof nuxt_plugin_moment_aef0d7e4 === 'function') {
    await nuxt_plugin_moment_aef0d7e4(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_toast_1ba1b90e === 'function') {
    await nuxt_plugin_toast_1ba1b90e(app.context, inject)
  }

  if (typeof nuxt_plugin_router_4e288e25 === 'function') {
    await nuxt_plugin_router_4e288e25(app.context, inject)
  }

  if (typeof nuxt_plugin_global_0a6ae274 === 'function') {
    await nuxt_plugin_global_0a6ae274(app.context, inject)
  }

  if (typeof nuxt_plugin_vform_f95cee7a === 'function') {
    await nuxt_plugin_vform_f95cee7a(app.context, inject)
  }

  if (typeof nuxt_plugin_urls_56d0cd3b === 'function') {
    await nuxt_plugin_urls_56d0cd3b(app.context, inject)
  }

  if (typeof nuxt_plugin_env_6e038494 === 'function') {
    await nuxt_plugin_env_6e038494(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_fb9c9a02 === 'function') {
    await nuxt_plugin_axios_fb9c9a02(app.context, inject)
  }

  if (typeof nuxt_plugin_nuxtclientinit_37cfbfdf === 'function') {
    await nuxt_plugin_nuxtclientinit_37cfbfdf(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_bootstrap_0f900877 === 'function') {
    await nuxt_plugin_bootstrap_0f900877(app.context, inject)
  }

  if (typeof nuxt_plugin_vuelazyload_f1f534be === 'function') {
    await nuxt_plugin_vuelazyload_f1f534be(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuexpersistedstate_1da59343 === 'function') {
    await nuxt_plugin_vuexpersistedstate_1da59343(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuexsharedmutations_13a55a87 === 'function') {
    await nuxt_plugin_vuexsharedmutations_13a55a87(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vueinfiniteloading_ba354f40 === 'function') {
    await nuxt_plugin_vueinfiniteloading_ba354f40(app.context, inject)
  }

  if (typeof nuxt_plugin_vuemultiselect_57bfe612 === 'function') {
    await nuxt_plugin_vuemultiselect_57bfe612(app.context, inject)
  }

  if (typeof nuxt_plugin_moneyformat_883ef0c6 === 'function') {
    await nuxt_plugin_moneyformat_883ef0c6(app.context, inject)
  }

  if (typeof nuxt_plugin_stringformat_e39a9d06 === 'function') {
    await nuxt_plugin_stringformat_e39a9d06(app.context, inject)
  }

  if (typeof nuxt_plugin_numberonlyinput_45f437e0 === 'function') {
    await nuxt_plugin_numberonlyinput_45f437e0(app.context, inject)
  }

  if (typeof nuxt_plugin_secondstimestamp_428bd625 === 'function') {
    await nuxt_plugin_secondstimestamp_428bd625(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuegtag_9c4c62de === 'function') {
    await nuxt_plugin_vuegtag_9c4c62de(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_gtm_5e4639ea === 'function') {
    await nuxt_plugin_gtm_5e4639ea(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // Wait for async component to be resolved first
  await new Promise((resolve, reject) => {
    // Ignore 404s rather than blindly replacing URL in browser
    if (process.client) {
      const { route } = router.resolve(app.context.route.fullPath)
      if (!route.matched.length) {
        return resolve()
      }
    }
    router.replace(app.context.route.fullPath, resolve, (err) => {
      // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
      if (!err._isRouter) return reject(err)
      if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

      // navigated to a different route in router guard
      const unregister = router.afterEach(async (to, from) => {
        if (process.server && ssrContext && ssrContext.url) {
          ssrContext.url = to.fullPath
        }
        app.context.route = await getRouteData(to)
        app.context.params = to.params || {}
        app.context.query = to.query || {}
        unregister()
        resolve()
      })
    })
  })

  return {
    store,
    app,
    router
  }
}

export { createApp, NuxtError }
